if (!customElements.get('countdown-overview')) {
	customElements.define(
		'countdown-overview',
		class CountdownOverview extends HTMLElement {
			connectedCallback() {
				// wait for layout, otherwise the widths are 0
				requestAnimationFrame(() => this.centerActiveItem());

				// desktop: drag the track with the left mouse button (touch devices scroll natively)
				this.addEventListener('mousedown', this.onMouseDown);
				this.addEventListener('click', this.onClick, true);
				// no native image / link dragging, it would cancel the scroll drag
				this.addEventListener('dragstart', (event) => event.preventDefault());
			}

			disconnectedCallback() {
				window.removeEventListener('mousemove', this.onMouseMove);
				window.removeEventListener('mouseup', this.onMouseUp);
			}

			// scroll the track (not the page) so the active campaign is in the middle
			centerActiveItem() {
				const activeItem = this.querySelector('.countdown-overview__item--active');
				if (!activeItem || this.scrollWidth <= this.clientWidth) return;

				const left = activeItem.offsetLeft - (this.clientWidth - activeItem.offsetWidth) / 2;
				this.scrollTo({ left: Math.max(0, left), behavior: 'instant' });
			}

			onMouseDown = (event) => {
				if (event.button !== 0) return;
				this.startX = event.pageX;
				this.startScrollLeft = this.scrollLeft;
				this.hasDragged = false;
				window.addEventListener('mousemove', this.onMouseMove);
				window.addEventListener('mouseup', this.onMouseUp);
			};

			onMouseMove = (event) => {
				const distance = event.pageX - this.startX;
				// small movements are still a click
				if (!this.hasDragged && Math.abs(distance) < 5) return;

				this.hasDragged = true;
				this.classList.add('is-dragging');
				this.scrollLeft = this.startScrollLeft - distance;
			};

			onMouseUp = () => {
				window.removeEventListener('mousemove', this.onMouseMove);
				window.removeEventListener('mouseup', this.onMouseUp);
				this.classList.remove('is-dragging');
			};

			// releasing the mouse after a drag must not open the campaign link
			onClick = (event) => {
				if (!this.hasDragged) return;
				event.preventDefault();
				event.stopPropagation();
				this.hasDragged = false;
			};
		},
	);
}
